// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"2ad71528","118":"229209c7","139":"3410194b","145":"d0138972","180":"25b27cb7","245":"e893a6e5","294":"5031ba39","331":"25b27cb7","386":"97407922","474":"667ecf64","502":"703298f5","575":"5fd94606","695":"236cf1da","746":"c1971343","850":"ac66c22a"}[chunkId] + ".chunk.css";
};